import React, { useState, useEffect } from "react";
import {
  Redirect,
  Route,
  Link,
  useParams,
  useLocation,
} from "react-router-dom";
import emailValidate from "services/emailValidate";
import LanguageSwitcher from "elements/LanguageSwitcher";
import api from "services/api";
import Translator, { __ } from "services/Translator";
import Logo from "elements/icons/Logo";
import Slider from "react-slick";

export default function Footer(props) {
  const location = useLocation();
  useEffect(() => {
    setTimeout(() => {
      // try {
      //   window.apg_f69cf96f_5984_4115_a2de_3b3301ce9bf0.init();
      // } catch (ex) {}
      try {
        window.xcm_b8b4804e_c667_4b58_9775_ed20efd0d5c6.init();
      } catch (ex) {}
    }, 2000);
  }, []);

  const currencyBrandSettings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 2,
    slidesToScroll: 2,
    variableWidth: true,
    // swipeToSlide: true,
    autoplay: true,
    // className: "center",
    // centerMode: true,
  };

  const gammingBrandSettings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 2,
    slidesToScroll: 2,
    variableWidth: true,
    // swipeToSlide: true,
    autoplay: true,
    // className: "center",
    // centerMode: true,
  };

  const cryptoBrandSettings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 5,
    slidesToScroll: 5,
    variableWidth: true,
    swipeToSlide: true,
    autoplay: false,

    responsive: [
      {
        breakpoint: 1300,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 4,
        },
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
        },
      },
      {
        breakpoint: 767,

        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
    ],
  };
  const settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 8,
    slidesToScroll: 8,
    variableWidth: true,
    swipeToSlide: true,
    responsive: [
      {
        breakpoint: 2000,
        settings: {
          slidesToShow: 6,
          slidesToScroll: 6,
        },
      },
      {
        breakpoint: 1600,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 5,
        },
      },
      {
        breakpoint: 1300,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 4,
        },
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
        },
      },
      {
        breakpoint: 767,

        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
    ],
  };
  // const location = useLocation();
  return (
    <>
      <footer>
        <section className="footerV2">
          <div className="container-lg">
            {location.pathname != "/exclusive" && (
              <>
                <div className="gamming_brands">
                  {!props.isMobileDevice && (
                    <>
                      <ul className="topMenu">
                        <li className="dotIgamingLogo">
                          <a target="_blank" href="https://dot-igaming.com">
                            {/* <img
                          className="hoverImg brand_img"
                          src={
                            require("../assets/images/common/dot-igaming-solid-white.svg")
                              .default
                          }
                        />
                        <img
                          className="solidImg brand_img"
                          src={
                            require("../assets/images/common/dot-igaming.svg")
                              .default
                          }
                        /> */}
                            <svg
                              className="dotiGamingLogo"
                              id="b8bfea57-ddb9-4253-92bc-61874563b518"
                              data-name="Layer 1"
                              xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 3500 1500"
                            >
                              <title>dotiGaming copy 2SVG</title>
                              <path d="M519.2,1291.1a125.6,125.6,0,0,1-109.9-63.5q-16.7-29.2-16.7-66t16.9-65.1a125.4,125.4,0,0,1,46.2-46.1c19.4-11.3,41-16.9,64.5-16.9a129.3,129.3,0,0,1,39.8,6.1,117.9,117.9,0,0,1,35.3,18.4V943.6l49.1-9.3v352.9H595.8v-24Q563.9,1291.1,519.2,1291.1Zm6.4-42.7a97.7,97.7,0,0,0,39.5-7.8,82.8,82.8,0,0,0,30.2-22.1V1105.6c-7.8-9.5-17.9-16.8-30.2-22.1a99.8,99.8,0,0,0-39.5-7.8c-15.7,0-30,3.6-42.9,11a79.6,79.6,0,0,0-30.5,30.7c-7.3,13.1-11,27.8-11,44.2s3.7,31,11,44.1a83,83,0,0,0,30.5,31.2A82.1,82.1,0,0,0,525.6,1248.4Z" />
                              <path d="M821.1,1292.1q-36.3,0-66-16.9a126.1,126.1,0,0,1-47.1-46.6q-17.6-29.7-17.5-66.1c0-24.5,5.8-46.5,17.2-66a129.9,129.9,0,0,1,47.1-46.6q30-17.4,66.3-17.4t66,17.4a130.1,130.1,0,0,1,46.9,46.6c11.4,19.5,17.2,41.5,17.2,66s-5.8,46.3-17.2,66.1a124.9,124.9,0,0,1-46.9,46.6Q857.4,1292.2,821.1,1292.1Zm.5-43.2a76.7,76.7,0,0,0,41.2-11.5,82.7,82.7,0,0,0,29.5-31.2q10.8-19.7,10.8-44.1t-10.8-43.5a85.7,85.7,0,0,0-29.5-31.2,79.8,79.8,0,0,0-83.2,0,85.4,85.4,0,0,0-29.7,31.2q-10.8,19.4-10.8,43.5t10.8,44.1a82.4,82.4,0,0,0,29.7,31.2A78.9,78.9,0,0,0,821.6,1248.9Z" />
                              <path d="M1090.1,1291.6c-23.9,0-42.2-5.5-55-16.7s-19.1-27.6-19.1-49.5V1078.6H963v-41.2h53V974.1l48.6-12.3v75.6h74.1v41.2h-74.1v136c0,12.4,2.8,21.3,8.5,26.7s15.2,8.1,28.3,8.1a102.2,102.2,0,0,0,18.4-1.5,96.3,96.3,0,0,0,17.4-4.9v41.8a113.1,113.1,0,0,1-22.8,5.1A177.6,177.6,0,0,1,1090.1,1291.6Z" />
                              <path d="M1206.9,1291.1a30.9,30.9,0,0,1-30.9-30.9,31.2,31.2,0,0,1,9.1-22.6,30.2,30.2,0,0,1,43.6,0,31.2,31.2,0,0,1,9.1,22.6,30.9,30.9,0,0,1-30.9,30.9Z" />
                              <path d="M1321.7,996.6a28.9,28.9,0,0,1-21.1-8.8,29.7,29.7,0,0,1-8.8-21.6,30.2,30.2,0,0,1,51.5-21.1,29.4,29.4,0,0,1,8.9,21.6,30.2,30.2,0,0,1-30.5,29.9Zm-24.5,290.6V1037.4h49.1v249.8Z" />
                              <path d="M1575,1292.6q-37.8,0-70.4-13.7a180.2,180.2,0,0,1-57.2-38.1,176.2,176.2,0,0,1-38.3-56.4c-9.2-21.4-13.7-44.4-13.7-69a176,176,0,0,1,13.5-68.9,171.6,171.6,0,0,1,38-56.5A179.9,179.9,0,0,1,1574,938.2a193.3,193.3,0,0,1,77.4,15.7,171.9,171.9,0,0,1,61.1,44.2l-35.4,33.9a125,125,0,0,0-46.1-34.4,141.9,141.9,0,0,0-57-11.8,124.9,124.9,0,0,0-89.8,37.3,127.2,127.2,0,0,0-26.7,41.3,140.5,140.5,0,0,0,0,102.1,128.7,128.7,0,0,0,26.7,41.4,121,121,0,0,0,40.5,27.8,128.2,128.2,0,0,0,49.8,9.8q30.9,0,55.7-12.8a110,110,0,0,0,59.7-85.9H1576v-44.6h167.9v18.1a178.6,178.6,0,0,1-12.8,67.8,170.4,170.4,0,0,1-35.6,54.9,161.2,161.2,0,0,1-53.7,36.6Q1610.9,1292.7,1575,1292.6Z" />
                              <path d="M1871.5,1291.6c-18.3,0-34.4-3.2-48.1-9.5s-24.6-15.3-32.4-26.8-11.8-24.7-11.8-39.7q0-35.4,27.3-55.5t73.8-20.1c24.6,0,47.1,4.4,67.8,13.2v-26q0-27-15.3-40.2c-10.1-8.9-25.2-13.3-45.1-13.3a129.4,129.4,0,0,0-35.6,5.2c-12.3,3.4-26.1,8.7-41.5,15.9L1792,1058q27.9-13.2,52.7-19.4a207.1,207.1,0,0,1,49.9-6.1q48.6,0,75.3,23t26.7,65.8v165.9h-48.5v-21.6a110.5,110.5,0,0,1-35.4,19.7A130.8,130.8,0,0,1,1871.5,1291.6Zm-45.7-77.5c0,12.4,5.3,22.4,15.7,29.9s24.1,11.3,40.8,11.3a108.8,108.8,0,0,0,36.3-5.9,82.6,82.6,0,0,0,29.5-18.1V1189a116.5,116.5,0,0,0-29.5-11.7,135.8,135.8,0,0,0-33.9-4c-18.3,0-32.7,3.8-43.2,11.3S1825.8,1202,1825.8,1214.1Z" />
                              <path d="M2053.1,1287.2V1037.4h49.1v23.5q27.9-28.4,70.2-28.4c17,0,32.2,3.7,45.6,11.3a81.1,81.1,0,0,1,31.4,30.9c10.2-14.1,22.4-24.6,36.6-31.7s30.2-10.5,47.9-10.5,34.9,4.1,48.8,12.2a85.9,85.9,0,0,1,32.6,34.2q11.8,21.8,11.8,51.2v157.1h-48.6V1138.5q0-29.4-15.4-46.4c-10.3-11.3-24.2-16.9-41.5-16.9-12.4,0-23.6,2.8-33.4,8.6s-18.3,14.1-25.5,25.2c.6,3.3,1.1,6.7,1.5,10.3s.5,7.2.5,10.8v157.1h-48.6V1138.5q0-29.4-15.8-46.4c-10.4-11.3-24.2-16.9-41.2-16.9-12.1,0-22.9,2.5-32.4,7.6s-17.6,12.7-24.5,22.8v181.6Z" />
                              <path d="M2508.6,996.6a28.7,28.7,0,0,1-21.1-8.8,29.3,29.3,0,0,1-8.8-21.6,30,30,0,0,1,29.9-29.9,30.1,30.1,0,0,1,30.4,30.4,28.7,28.7,0,0,1-8.8,21.1A29.3,29.3,0,0,1,2508.6,996.6Zm-24.5,290.6V1037.4h49v249.8Z" />
                              <path d="M2591,1287.2V1037.4h49.1v25.5c19.3-20.3,44.4-30.4,75.1-30.4,19.3,0,36.3,4.1,50.8,12.2a88.9,88.9,0,0,1,34.4,34.4q12.4,22.1,12.5,51v157.1h-49.1V1138.5c0-19.6-5.5-35.1-16.7-46.4s-26.3-16.9-45.6-16.9c-13.1,0-24.8,2.8-35.1,8.6a76.9,76.9,0,0,0-26.3,24.3v179.1Z" />
                              <path d="M2992.5,1392.3a224.8,224.8,0,0,1-53-6.4,189.1,189.1,0,0,1-47.1-18.2l19.2-38.3a221.8,221.8,0,0,0,40.9,16,151.7,151.7,0,0,0,38.6,5.1q33.3,0,50.3-14.7t16.9-44.2v-28.4q-32.4,26-75.1,26-34.8,0-63.3-17.2a127.9,127.9,0,0,1-45.4-46.4c-11.3-19.4-16.9-41-16.9-64.5s5.7-45.6,17.1-65.1a129.2,129.2,0,0,1,45.9-46.1c19.2-11.3,40.5-16.9,64.1-16.9a124.2,124.2,0,0,1,39.5,6.3,118.1,118.1,0,0,1,35.1,19.2v-21.1h48.1v253.7q0,49.2-29.4,75.1C3058.3,1383.6,3029.9,1392.3,2992.5,1392.3Zm-2.9-145.3a94.7,94.7,0,0,0,39-7.9,79.8,79.8,0,0,0,29.7-21.6V1104.6c-7.5-8.8-17.3-15.8-29.4-21.1a98.5,98.5,0,0,0-39.3-7.8c-15.7,0-29.9,3.6-42.5,11a81.5,81.5,0,0,0-29.9,30.4c-7.4,13-11,27.6-11,44s3.6,30.5,11,43.4a84.4,84.4,0,0,0,30.2,30.9A80.2,80.2,0,0,0,2989.6,1247Z" />
                              <path d="M1858.5,423.4a177.2,177.2,0,0,1,106.5-2.3c-7.3,116.3-83.3,222-200.5,261.4l-2.3.8a177.5,177.5,0,0,1-15.7-34.2C1715.1,556,1765.4,454.7,1858.5,423.4Z" />
                              <path d="M1950,308.7a294.2,294.2,0,0,1,15.2,80.2,208,208,0,0,0-116.7,4.9c-109.3,36.8-168.4,155.9-131.6,265.3a207.2,207.2,0,0,0,14.2,32.6c-144.4,30.5-292.1-51.3-340.3-194.6-52.1-154.4,30.9-321.8,185.4-373.8S1898,154.3,1950,308.7Z" />
                              <path d="M1965.3,388.9a313.9,313.9,0,0,1-.3,32.2,178.1,178.1,0,0,1,119.2,114.3c31.4,93.1-18.8,194.3-112,225.7-80.9,27.3-168.1-7.2-210-77.8a298.8,298.8,0,0,1-31.1,8.4c47.5,88.1,153.2,131.9,251.1,99,109.4-36.9,168.4-155.9,131.6-265.3A209.5,209.5,0,0,0,1965.3,388.9Z" />
                            </svg>
                          </a>
                        </li>
                        <li>
                          <a
                            rel="nofollow noopener noreferrer"
                            target="_blank"
                            href="https://cryptogamba.com"
                          >
                            <img
                              alt="cryptogamba"
                              src={
                                require("assets/images/logos/cryptogamba.svg")
                                  .default
                              }
                            />
                          </a>
                        </li>
                        <li>
                          <img
                            alt="evolution-gaming"
                            src={
                              require("assets/images/v2/brands/evolution-gaming.webp")
                                .default
                            }
                          />
                        </li>
                        <li>
                          <img
                            alt="hacksaw-gaming"
                            src={
                              require("assets/images/v2/brands/hacksaw-gaming.webp")
                                .default
                            }
                          />
                        </li>
                        <li>
                          <img
                            alt="net-ent"
                            src={
                              require("assets/images/v2/brands/net-ent.webp")
                                .default
                            }
                          />
                        </li>
                      </ul>
                      <ul className="bottomMenu">
                        <li>
                          <img
                            alt="pragmatic"
                            src={
                              require("assets/images/v2/brands/pragmatic.webp")
                                .default
                            }
                          />
                        </li>
                        <li>
                          <img
                            alt="microgaming-logo"
                            src={
                              require("assets/images/v2/brands/microgaming-logo.webp")
                                .default
                            }
                          />
                        </li>
                        <li>
                          {/* <img
                    alt=""
                    src={
                      require("assets/images/v2/brands/payop-logo-white.webp")
                        .default
                    }
                  /> */}
                          <svg
                            id="payOp"
                            className="payOpIcon"
                            data-name=""
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 302.2 77.04"
                          >
                            <defs>
                              <style></style>
                            </defs>
                            <path
                              class="cls-1"
                              d="M164,1.26V26.72a18.85,18.85,0,0,1-1.76,8h0a13.61,13.61,0,0,1-4.72,5.71,12.85,12.85,0,0,1-7.23,2c-4.38,0-7.61-1.39-9.78-4.07s-3.4-6.38-3.4-10.93V1.26H125.52V27.94A32.89,32.89,0,0,0,128,41.22h0a20.71,20.71,0,0,0,7.84,9h0A24.54,24.54,0,0,0,149,53.51a19.6,19.6,0,0,0,9.88-2.34,17.44,17.44,0,0,0,5.13-4.62v1.59a22.58,22.58,0,0,1-1.77,9.27h0a14.06,14.06,0,0,1-5.12,6.38,14.5,14.5,0,0,1-8.42,2.31A17.23,17.23,0,0,1,140.05,64a15,15,0,0,1-5.91-6l-.37-.72L124,62.57l.34.68a23.28,23.28,0,0,0,9.92,10.32h0A31,31,0,0,0,148.94,77a26.73,26.73,0,0,0,14.29-3.71A23.68,23.68,0,0,0,172.5,63a32.73,32.73,0,0,0,3.23-15V1.26Z"
                            />
                            <path
                              class="cls-1"
                              d="M113.46,13.18a26,26,0,0,0-9.77-9.61A27.86,27.86,0,0,0,65.9,13.45a25.72,25.72,0,0,0-3.56,13.41A28.21,28.21,0,0,0,65.7,40.51a26.45,26.45,0,0,0,4,5.5,28.58,28.58,0,0,0,5.16,4.27h0A24.73,24.73,0,0,0,88.2,54a22.62,22.62,0,0,0,11.85-3h0A22.07,22.07,0,0,0,106,45.77V54h11.14v-27a26.12,26.12,0,0,0-3.67-13.75ZM103.41,35a16,16,0,0,1-21.76,5.74A16.89,16.89,0,0,1,76,35a16,16,0,0,1-2-7.95,16,16,0,0,1,2-8,16.37,16.37,0,0,1,5.63-5.74h0a15.71,15.71,0,0,1,8-2.21,15.94,15.94,0,0,1,8,2.21,15.57,15.57,0,0,1,5.64,5.7,15.82,15.82,0,0,1,2,8,16.36,16.36,0,0,1-2,8Z"
                            />
                            <path
                              class="cls-1"
                              d="M51.17,13.48A26.37,26.37,0,0,0,41.39,3.7,26.9,26.9,0,0,0,27.43,0,27.46,27.46,0,0,0,13.48,3.6,26.56,26.56,0,0,0,3.6,13.18h0A26.43,26.43,0,0,0,0,26.93V64.61H11.68V47.7a26.59,26.59,0,0,0,4.62,3.36,21.32,21.32,0,0,0,5.53,2.21,23.79,23.79,0,0,0,6,.75,27.44,27.44,0,0,0,13.88-3.5,25.73,25.73,0,0,0,9.58-9.68h0a28.14,28.14,0,0,0,3.46-14,25.61,25.61,0,0,0-3.56-13.41ZM41,35a16.54,16.54,0,0,1-5.63,5.83,15.17,15.17,0,0,1-8,2.14,15.51,15.51,0,0,1-8-2.14A17.5,17.5,0,0,1,13.75,35a15.81,15.81,0,0,1-2-7.94,15.6,15.6,0,0,1,2-7.91,16,16,0,0,1,5.64-5.74,15.6,15.6,0,0,1,8-2.14,14.56,14.56,0,0,1,8,2.14A15.39,15.39,0,0,1,41,19.08a16,16,0,0,1,2,8A15.85,15.85,0,0,1,41,35Z"
                            />
                            <path
                              class="cls-1"
                              d="M298.56,13.48a26.3,26.3,0,0,0-9.78-9.78A26.84,26.84,0,0,0,274.83,0,27.43,27.43,0,0,0,260.88,3.6,26.41,26.41,0,0,0,251,13.18h0a26.41,26.41,0,0,0-3.57,13.75V64.61h11.68V47.74a25.38,25.38,0,0,0,4.65,3.36,21.66,21.66,0,0,0,5.53,2.2,23.85,23.85,0,0,0,6,.75,27.2,27.2,0,0,0,13.85-3.46,25.73,25.73,0,0,0,9.58-9.68h0a28.33,28.33,0,0,0,3.49-14,26.39,26.39,0,0,0-3.63-13.45ZM288.41,35a16.57,16.57,0,0,1-5.64,5.83,15.93,15.93,0,0,1-15.95,0A17.5,17.5,0,0,1,261.18,35a15.92,15.92,0,0,1-2-7.94,15.71,15.71,0,0,1,2-7.91,16.15,16.15,0,0,1,5.64-5.74,15.58,15.58,0,0,1,8-2.14,14.56,14.56,0,0,1,7.95,2.14h0a15.62,15.62,0,0,1,5.63,5.7,16.46,16.46,0,0,1,0,15.93Z"
                            />
                            <path
                              class="cls-1"
                              d="M233.17,46a27.81,27.81,0,0,1-11.54,8.28,26,26,0,0,1-14.29,1.09,26.88,26.88,0,0,1-13.11-6.25,30.42,30.42,0,0,1-7.81-11.85,28,28,0,0,1-1.49-9.34v0l-3-.78a1,1,0,0,1-.37-.24h0a.53.53,0,0,1-.1-.51.56.56,0,0,1,.27-.37l10.86-6.38a.71.71,0,0,1,.48-.07.56.56,0,0,1,.37.27l3.29,5.57,3.13,5.29s0,0,0,.07,0,0,0,0a1.13,1.13,0,0,1,0,.3.59.59,0,0,1-.74.44l-2.38-.61s.37,1.6.61,2.38a17.57,17.57,0,0,0,4.45,6.79,15.26,15.26,0,0,0,7.5,3.56,14.62,14.62,0,0,0,8.18-.64,15.61,15.61,0,0,0,6.63-4.76,16.73,16.73,0,0,0,2.88-15.68,15.53,15.53,0,0,0-4.48-6.65A15.93,15.93,0,0,0,206.86,13a16.34,16.34,0,0,0-6.55,4.58,17.87,17.87,0,0,0-1.5,2.07l-3.36-5.74a1.32,1.32,0,0,0-.61-.44,1.09,1.09,0,0,0-.78.1l-7.16,4.18A26.21,26.21,0,0,1,191.45,10a28.63,28.63,0,0,1,11.44-8,27.78,27.78,0,0,1,27.33,5.12,28.14,28.14,0,0,1,4.68,5.3,26.16,26.16,0,0,1,3.16,6.35,27.64,27.64,0,0,1,1,14.33A27.08,27.08,0,0,1,233.17,46Z"
                            />
                          </svg>
                        </li>

                        <li>
                          <img
                            alt="begambleawareorg"
                            src={
                              require("assets/images/v2/brands/begambleawareorg.webp")
                                .default
                            }
                          />
                        </li>
                      </ul>
                    </>
                  )}
                  {props.isMobileDevice && (
                    <>
                      <ul className="gammingBrandSettings">
                        <Slider {...currencyBrandSettings}>
                          <li className="dotIgamingLogo">
                            <a target="_blank" href="https://dot-igaming.com">
                              <img
                                alt="dot-igaming"
                                className="hoverImg brand_img"
                                src={
                                  require("../assets/images/common/dot-igaming-solid-white.svg")
                                    .default
                                }
                              />
                              <img
                                alt="dot-igaming"
                                className="solidImg brand_img"
                                src={
                                  require("../assets/images/common/dot-igaming.svg")
                                    .default
                                }
                              />
                            </a>
                          </li>
                          <li>
                            <img
                              alt="evolution-gaming"
                              src={
                                require("assets/images/v2/brands/evolution-gaming.webp")
                                  .default
                              }
                            />
                          </li>
                          <li>
                            <img
                              alt="hacksaw-gaming"
                              src={
                                require("assets/images/v2/brands/hacksaw-gaming.webp")
                                  .default
                              }
                            />
                          </li>
                          <li>
                            <img
                              alt="net-ent"
                              src={
                                require("assets/images/v2/brands/net-ent.webp")
                                  .default
                              }
                            />
                          </li>
                          <li>
                            <img
                              alt="pragmatic"
                              src={
                                require("assets/images/v2/brands/pragmatic.webp")
                                  .default
                              }
                            />
                          </li>

                          <li>
                            <img
                              alt="microgaming"
                              src={
                                require("assets/images/v2/brands/microgaming-logo.webp")
                                  .default
                              }
                            />
                          </li>
                          <li>
                            {/* <img
                    alt=""
                    src={
                      require("assets/images/v2/brands/payop-logo-white.webp")
                        .default
                    }
                  /> */}
                            <svg
                              id="payOp"
                              className="payOpIcon"
                              data-name=""
                              xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 302.2 77.04"
                            >
                              <defs>
                                <style></style>
                              </defs>
                              <path
                                class="cls-1"
                                d="M164,1.26V26.72a18.85,18.85,0,0,1-1.76,8h0a13.61,13.61,0,0,1-4.72,5.71,12.85,12.85,0,0,1-7.23,2c-4.38,0-7.61-1.39-9.78-4.07s-3.4-6.38-3.4-10.93V1.26H125.52V27.94A32.89,32.89,0,0,0,128,41.22h0a20.71,20.71,0,0,0,7.84,9h0A24.54,24.54,0,0,0,149,53.51a19.6,19.6,0,0,0,9.88-2.34,17.44,17.44,0,0,0,5.13-4.62v1.59a22.58,22.58,0,0,1-1.77,9.27h0a14.06,14.06,0,0,1-5.12,6.38,14.5,14.5,0,0,1-8.42,2.31A17.23,17.23,0,0,1,140.05,64a15,15,0,0,1-5.91-6l-.37-.72L124,62.57l.34.68a23.28,23.28,0,0,0,9.92,10.32h0A31,31,0,0,0,148.94,77a26.73,26.73,0,0,0,14.29-3.71A23.68,23.68,0,0,0,172.5,63a32.73,32.73,0,0,0,3.23-15V1.26Z"
                              />
                              <path
                                class="cls-1"
                                d="M113.46,13.18a26,26,0,0,0-9.77-9.61A27.86,27.86,0,0,0,65.9,13.45a25.72,25.72,0,0,0-3.56,13.41A28.21,28.21,0,0,0,65.7,40.51a26.45,26.45,0,0,0,4,5.5,28.58,28.58,0,0,0,5.16,4.27h0A24.73,24.73,0,0,0,88.2,54a22.62,22.62,0,0,0,11.85-3h0A22.07,22.07,0,0,0,106,45.77V54h11.14v-27a26.12,26.12,0,0,0-3.67-13.75ZM103.41,35a16,16,0,0,1-21.76,5.74A16.89,16.89,0,0,1,76,35a16,16,0,0,1-2-7.95,16,16,0,0,1,2-8,16.37,16.37,0,0,1,5.63-5.74h0a15.71,15.71,0,0,1,8-2.21,15.94,15.94,0,0,1,8,2.21,15.57,15.57,0,0,1,5.64,5.7,15.82,15.82,0,0,1,2,8,16.36,16.36,0,0,1-2,8Z"
                              />
                              <path
                                class="cls-1"
                                d="M51.17,13.48A26.37,26.37,0,0,0,41.39,3.7,26.9,26.9,0,0,0,27.43,0,27.46,27.46,0,0,0,13.48,3.6,26.56,26.56,0,0,0,3.6,13.18h0A26.43,26.43,0,0,0,0,26.93V64.61H11.68V47.7a26.59,26.59,0,0,0,4.62,3.36,21.32,21.32,0,0,0,5.53,2.21,23.79,23.79,0,0,0,6,.75,27.44,27.44,0,0,0,13.88-3.5,25.73,25.73,0,0,0,9.58-9.68h0a28.14,28.14,0,0,0,3.46-14,25.61,25.61,0,0,0-3.56-13.41ZM41,35a16.54,16.54,0,0,1-5.63,5.83,15.17,15.17,0,0,1-8,2.14,15.51,15.51,0,0,1-8-2.14A17.5,17.5,0,0,1,13.75,35a15.81,15.81,0,0,1-2-7.94,15.6,15.6,0,0,1,2-7.91,16,16,0,0,1,5.64-5.74,15.6,15.6,0,0,1,8-2.14,14.56,14.56,0,0,1,8,2.14A15.39,15.39,0,0,1,41,19.08a16,16,0,0,1,2,8A15.85,15.85,0,0,1,41,35Z"
                              />
                              <path
                                class="cls-1"
                                d="M298.56,13.48a26.3,26.3,0,0,0-9.78-9.78A26.84,26.84,0,0,0,274.83,0,27.43,27.43,0,0,0,260.88,3.6,26.41,26.41,0,0,0,251,13.18h0a26.41,26.41,0,0,0-3.57,13.75V64.61h11.68V47.74a25.38,25.38,0,0,0,4.65,3.36,21.66,21.66,0,0,0,5.53,2.2,23.85,23.85,0,0,0,6,.75,27.2,27.2,0,0,0,13.85-3.46,25.73,25.73,0,0,0,9.58-9.68h0a28.33,28.33,0,0,0,3.49-14,26.39,26.39,0,0,0-3.63-13.45ZM288.41,35a16.57,16.57,0,0,1-5.64,5.83,15.93,15.93,0,0,1-15.95,0A17.5,17.5,0,0,1,261.18,35a15.92,15.92,0,0,1-2-7.94,15.71,15.71,0,0,1,2-7.91,16.15,16.15,0,0,1,5.64-5.74,15.58,15.58,0,0,1,8-2.14,14.56,14.56,0,0,1,7.95,2.14h0a15.62,15.62,0,0,1,5.63,5.7,16.46,16.46,0,0,1,0,15.93Z"
                              />
                              <path
                                class="cls-1"
                                d="M233.17,46a27.81,27.81,0,0,1-11.54,8.28,26,26,0,0,1-14.29,1.09,26.88,26.88,0,0,1-13.11-6.25,30.42,30.42,0,0,1-7.81-11.85,28,28,0,0,1-1.49-9.34v0l-3-.78a1,1,0,0,1-.37-.24h0a.53.53,0,0,1-.1-.51.56.56,0,0,1,.27-.37l10.86-6.38a.71.71,0,0,1,.48-.07.56.56,0,0,1,.37.27l3.29,5.57,3.13,5.29s0,0,0,.07,0,0,0,0a1.13,1.13,0,0,1,0,.3.59.59,0,0,1-.74.44l-2.38-.61s.37,1.6.61,2.38a17.57,17.57,0,0,0,4.45,6.79,15.26,15.26,0,0,0,7.5,3.56,14.62,14.62,0,0,0,8.18-.64,15.61,15.61,0,0,0,6.63-4.76,16.73,16.73,0,0,0,2.88-15.68,15.53,15.53,0,0,0-4.48-6.65A15.93,15.93,0,0,0,206.86,13a16.34,16.34,0,0,0-6.55,4.58,17.87,17.87,0,0,0-1.5,2.07l-3.36-5.74a1.32,1.32,0,0,0-.61-.44,1.09,1.09,0,0,0-.78.1l-7.16,4.18A26.21,26.21,0,0,1,191.45,10a28.63,28.63,0,0,1,11.44-8,27.78,27.78,0,0,1,27.33,5.12,28.14,28.14,0,0,1,4.68,5.3,26.16,26.16,0,0,1,3.16,6.35,27.64,27.64,0,0,1,1,14.33A27.08,27.08,0,0,1,233.17,46Z"
                              />
                            </svg>
                          </li>
                          <li>
                            <img
                              alt="plus"
                              className="plus18Icon"
                              src={
                                require("assets/images/v2/brands/plus.webp")
                                  .default
                              }
                            />
                          </li>
                          <li>
                            <img
                              alt="begambleawareorg"
                              src={
                                require("assets/images/v2/brands/begambleawareorg.webp")
                                  .default
                              }
                            />
                          </li>
                        </Slider>
                      </ul>
                    </>
                  )}
                </div>

                <div className="footer_top">
                  <div className="row">
                    <div className="col-6 col-md-2">
                      <div className="links_section">
                        <div className="links_heading">{__("Information")}</div>
                        <ul>
                          <li>
                            <Link to="/about">{__("About GJ")}</Link>
                          </li>
                          <li>
                            <Link to="/vip">{__("VIP")}</Link>
                          </li>
                          <li>
                            <Link to="/promotions">{__("Promotions")}</Link>
                          </li>
                          <li>
                            <a
                              href="https://geniepartners.com"
                              target="_blank"
                              rel="noreferrer noopener"
                            >
                              {__("Partners")}
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div className="col-6 col-md-2">
                      <div className="links_section">
                        <div className="links_heading">{__("Legal info")}</div>
                        <ul>
                          <li>
                            <Link to="/terms-and-conditions">
                              {__("Terms and conditions")}
                            </Link>
                          </li>
                          <li>
                            <Link to="/privacy-policy">
                              {__("Privacy policy")}
                            </Link>
                          </li>
                          <li>
                            <Link to="/bonus-terms">{__("Bonus Terms")}</Link>
                          </li>
                          <li className="qw">
                            <Link to="/aml-policy">{__("AML Policy")}</Link>
                          </li>
                          <li>
                            <Link to="/responsible-gaming">
                              {__("Responsible Gaming")}
                            </Link>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div className="col-6 col-md-2">
                      <div className="links_section">
                        <div className="links_heading">{__("services")}</div>
                        <ul>
                          <li>
                            <Link to="/games/slots">{__("Casino Games")}</Link>
                          </li>
                          <li>
                            <Link to="/games/live-casino">
                              {__("Live Casino")}
                            </Link>
                          </li>
                          <li>
                            <Link to="/races">{__("Races")}</Link>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div className="col-6 col-md-2">
                      <div className="links_section">
                        <div className="links_heading">{__("Company")}</div>

                        <ul>
                          <li>{__("Meta Bliss Group B.V.")}</li>
                          <li>{__("Korporaalweg 10")}</li>
                          <li>{__("Willemstad, Curacao")}</li>
                          <li>
                            <a
                              className="active"
                              href="mailto:info@geniejackpot.com"
                            >
                              {__("info@geniejackpot.com")}
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div className="col-12 col-md-4">
                      <>
                        <div className="license_area">
                          <div className="license_logo_area">
                            {/* <div
                              className="curacao_license_area"
                              id="apg-f69cf96f-5984-4115-a2de-3b3301ce9bf0"
                              data-apg-seal-id="f69cf96f-5984-4115-a2de-3b3301ce9bf0"
                              data-apg-image-size="80"
                              data-apg-image-type="basic-light-large"
                            ></div> */}
                            <a
                              target="_blank"
                              href="https://cert.gcb.cw/certificate?id=ZXlKcGRpSTZJbFpWZUVsYVVHYzNSalpKTnpsR1EzWnFjRUpGVlZFOVBTSXNJblpoYkhWbElqb2lVVzV2Y1VFemVGaHBRalJOYVhCYWRuTmxRVEJaTjI1SVZVVmlWblJqZUVzdllWcE5lR3BJTkdWU01EMGlMQ0p0WVdNaU9pSmpPR1E1T1dNMVkyUTFOREk1TVdFMlpHTmhOMlV4T0RVeU1HVXpOamN5WVdVeU4yTmlOakEwTmpBek9Ua3daalpsTVdJeE0yWTNNek5oTW1OallUZzFJaXdpZEdGbklqb2lJbjA9"
                            >
                              <img
                                style={{ width: "90px" }}
                                src="https://portal.gamingcontrolcuracao.org/uploads/documents/GCB_Seal.svg"
                              />
                            </a>
                            <div
                              id="xcm-b8b4804e-c667-4b58-9775-ed20efd0d5c6"
                              data-xcm-seal-id="b8b4804e-c667-4b58-9775-ed20efd0d5c6"
                              data-xcm-image-size="80"
                              data-xcm-image-type="basic-light-large"
                            ></div>
                          </div>

                          <div className="plus18IconArea">
                            <img
                              alt="plus"
                              className="plus18Icon"
                              src={
                                require("assets/images/v2/brands/plus.webp")
                                  .default
                              }
                            />
                          </div>
                        </div>
                        <p className="licenseTextArea">
                          {__(
                            "Our platform provides an exciting gaming adventure that involves risk-taking. You must be at least 18 years of age to join and participate. Please be aware that we are not liable for any breaches of local i-gaming regulations. Enjoy your time responsibly on Genie Jackpot."
                          )}
                        </p>
                      </>
                    </div>
                    <div className="clearfix"></div>
                  </div>
                </div>
                <div className="currency_brands">
                  {!props.isMobileDevice && (
                    <>
                      <ul className="top_currency">
                        {/* <Slider {...cryptoBrandSettings}> */}
                        <li>
                          <img
                            alt="bitcoin"
                            src={
                              require("assets/images/v2/crypto/bitcoin@1x.avif")
                                .default
                            }
                          />
                        </li>
                        <li>
                          <img
                            alt="ethereum"
                            src={
                              require("assets/images/v2/crypto/ethereum@1x.avif")
                                .default
                            }
                          />
                        </li>
                        <li>
                          <img
                            alt="tether"
                            src={
                              require("assets/images/v2/crypto/tether@1x.avif")
                                .default
                            }
                          />
                        </li>
                        <li>
                          <img
                            alt="binance"
                            src={
                              require("assets/images/v2/crypto/binance@1x.avif")
                                .default
                            }
                          />
                        </li>
                        <li>
                          <img
                            alt="tron"
                            src={
                              require("assets/images/v2/crypto/tron@1x.avif")
                                .default
                            }
                          />
                        </li>
                        <li>
                          <img
                            alt="dogecoin"
                            src={
                              require("assets/images/v2/crypto/dogecoin-full-logo.png")
                                .default
                            }
                          />
                        </li>
                        <li>
                          <img
                            alt="litecoin1"
                            src={
                              require("assets/images/v2/crypto/litecoin1-gj.webp")
                                .default
                            }
                          />
                        </li>
                        <li>
                          <img
                            alt="xrp1"
                            src={
                              require("assets/images/v2/crypto/xrp1-gj.webp")
                                .default
                            }
                          />
                        </li>
                      </ul>
                    </>
                  )}
                </div>
              </>
            )}

            <div className="footer_bottom">
              <div className="logo_and_social_links">
                <img
                  className="footerGeniLogo"
                  alt="genie"
                  src={
                    require("assets/images/v2/common/genie-footer.svg").default
                  }
                />
                <div className="copyright_text">
                  Copyright © {new Date().getFullYear()} geniejackpot.com
                  <br />
                  All rights reserved.
                </div>
              </div>

              {props.isMobileDeviceByViewPort && (
                <div className="license_area ">
                  <div className="license_text">
                    {__(
                      "Genie Jackpot is owned and operated by Meta Bliss Group B.V., a company incorporated in Curacao with company registration number 159718 and having its registered address at Korporaalweg 10, Willemstad, Curaçao. Meta Bliss Group B.V. operates this website under licence number OGL/2024/1303/1172 issued by the GCB."
                    )}{" "}
                    <br /> <br />
                    {__(
                      "REDGIANT Ltd, Reg No HE437804, having its registered address at Voukourestiou, 25, NEPTUNE HOUSE, Floor 1, Room/Office 11 Jacket 3045, Limassol, Cyprus is a wholly owned subsidiary of Meta Bliss Group B.V. REDGIANT Ltd, acts as a paying and operational agent on behalf of Meta Bliss Group B.V."
                    )}
                  </div>
                </div>
              )}

              {!props.isMobileDeviceByViewPort && (
                <div className="license_area">
                  <div className="license_logo_area d-none">
                    {/* <div
                      className="curacao_license_area"
                      id="apg-f69cf96f-5984-4115-a2de-3b3301ce9bf0"
                      data-apg-seal-id="f69cf96f-5984-4115-a2de-3b3301ce9bf0"
                      data-apg-image-size="45"
                      data-apg-image-type="basic-light-large"
                    ></div> */}
                    <a
                      target="_blank"
                      href="https://cert.gcb.cw/certificate?id=ZXlKcGRpSTZJbFpWZUVsYVVHYzNSalpKTnpsR1EzWnFjRUpGVlZFOVBTSXNJblpoYkhWbElqb2lVVzV2Y1VFemVGaHBRalJOYVhCYWRuTmxRVEJaTjI1SVZVVmlWblJqZUVzdllWcE5lR3BJTkdWU01EMGlMQ0p0WVdNaU9pSmpPR1E1T1dNMVkyUTFOREk1TVdFMlpHTmhOMlV4T0RVeU1HVXpOamN5WVdVeU4yTmlOakEwTmpBek9Ua3daalpsTVdJeE0yWTNNek5oTW1OallUZzFJaXdpZEdGbklqb2lJbjA9"
                    >
                      <img
                        style={{ width: "90px" }}
                        src="https://portal.gamingcontrolcuracao.org/uploads/documents/GCB_Seal.svg"
                      />
                    </a>
                    <div
                      id="xcm-b8b4804e-c667-4b58-9775-ed20efd0d5c6"
                      data-xcm-seal-id="b8b4804e-c667-4b58-9775-ed20efd0d5c6"
                      data-xcm-image-size="45"
                      data-xcm-image-type="basic-light-large"
                    ></div>
                  </div>
                  <div className="license_text">
                    {__(
                      "Genie Jackpot is owned and operated by Meta Bliss Group B.V., a company incorporated in Curacao with company registration number 159718 and having its registered address at Korporaalweg 10, Willemstad, Curaçao. Meta Bliss Group B.V. operates this website under licence number OGL/2024/1303/1172 issued by the GCB."
                    )}{" "}
                    <br /> <br />
                    {__(
                      "REDGIANT Ltd, Reg No HE437804, having its registered address at Voukourestiou, 25, NEPTUNE HOUSE, Floor 1, Room/Office 11 Jacket 3045, Limassol, Cyprus is a wholly owned subsidiary of Meta Bliss Group B.V. REDGIANT Ltd, acts as a paying and operational agent on behalf of Meta Bliss Group B.V."
                    )}
                  </div>
                  <div className="cryptocasinos_approved_logo"></div>
                </div>
              )}
            </div>
          </div>
        </section>
      </footer>
    </>
  );
}
